import { FC } from 'react';

import { Section, SectionContent, SectionItem, SectionTitle } from './atoms';
import { CampaignDetail } from '@/apis/core';

interface CspDetailsSectionProps {
  campaign: CampaignDetail;
}

const CspDetailsSection: FC<CspDetailsSectionProps> = ({ campaign }) => {
  const { csp } = campaign.brand;
  return (
    <Section>
      <SectionTitle>CSP Details</SectionTitle>
      <SectionContent>
        <SectionItem title="CSP Legal Name">{csp.companyName}</SectionItem>
        <SectionItem title="CSP ID">{csp.uid}</SectionItem>
        <SectionItem title="Email Address">{csp.email}</SectionItem>
        <SectionItem title="Phone Number">{csp.phone}</SectionItem>
      </SectionContent>
    </Section>
  );
};

export default CspDetailsSection;
